<template>
  <Link
    :href="route(`${routePrefix}.modules.edit`, { id: feature.data.id })"
    v-for="(feature, key) in modules?.data" :key="key"
    class="d-block"
  >
    <colored-icon
      v-if="feature.data.attributes.icon_class"
      :icon-class="feature.data.attributes.icon_class"
      :color="feature.data.attributes.icon_color"
      :shadow="false"
    ></colored-icon>
    {{ feature.data.attributes.name }}
  </Link>
</template>

<script>
import ColoredIcon from "@kanrisha/components/Icons/ColoredIcon";
import { Link } from '@inertiajs/vue3';

export default {
  components: {
    ColoredIcon,
    Link,
  },
  props: {
    modules: { type: Object, default: () => {} },
  },
  setup(props) {

    return {

    }
  },
};
</script>